'use strict';

import React, { PropTypes } from 'react';
import Primary from './Primary.js';

const Calendar = React.createClass({
  displayName: "Calendar",
  propTypes: {
    primaries: PropTypes.array
  },
  render() {
    const createRow = (d) => {
      const key = `${d.state_short}_${d.party}`;
      return <Primary item={d} key={key} />;
    };
    const css = require('./Calendar.scss');

    return (
      <div className={css.primContainer}>
        {this.props.primaries.map(createRow)}
      </div>
    );
  }
});

export default Calendar;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Calendar.js
 **/